<button
  type="button"
  class="search-and-filter-button"
  mat-button
  aria-label="search / filter"
  >
  @if (!drawer?.opened) {
    <mat-icon>chevron_left</mat-icon>
  }
  @if (!drawer?.opened) {
    <span> Assignables by Page</span>
  }
  @if (drawer?.opened) {
    <mat-icon>chevron_right</mat-icon>
  }
</button>
